/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */

import { run } from './CrownHeightMapViewer';

window.addEventListener('WebComponentsReady', () => {
  run(document.getElementById('viewer'));
  document.getElementById('gui').style.display = 'block';
});
